{
  "it": {
    "customer": {
      "actions": {
        "addCompany": "Aggiungi organizzazione",
        "addCustomer": "Aggiungi cliente",
        "addSecondaryContact": "Aggiungi contatto secondario",
        "add_email_address": "Aggiungi indirizzo email",
        "bulk_import": "Importa clienti",
        "cancel": "Annulla",
        "changeProfilePicture": "Cambia immagine del profilo",
        "createNewCustomer": "Aggiungi nuovo cliente...",
        "goToCustomerProfile": "Vai alla pagina di contatto del cliente",
        "new": "Cliente",
        "profilePictureFormat": "L'immagine deve avere una dimensione minima di <strong>300x300px</strong>",
        "removeCompany": "Rimuovi dati organizzazione",
        "removeCustomer": "Rimuovi l'assegnazione di questo cliente",
        "removeSecondaryContact": "Rimuovi contatto secondario",
        "save": "Salva",
        "searchCustomer": "Cerca cliente",
        "submit": "Salva",
        "uploadProfilePicture": "Carica un'immagine del profilo"
      },
      "attributes": {
        "address": "Indirizzo",
        "birth_date": "Data di nascita",
        "categories": {
          "enduser": "Acquirente occupante",
          "investor": "Investitore"
        },
        "category": "Tipo di cliente",
        "company_name": "Nome organizzazione",
        "company_vat": "Partita IVA",
        "email_address": "Email",
        "email_address_secondary": "Email contatto secondario",
        "email_notifications_interval": {
          "daily": "Una volta al giorno (verso mezzogiorno)",
          "hourly": "Ogni ora",
          "twice_daily": "Due volte al giorno (mezzogiorno/sera)",
          "weekly": "Una volta a settimana (lunedì a mezzogiorno)"
        },
        "first_name": "Nome",
        "iban": "IBAN",
        "internal_note": "Nota interna",
        "language": "Lingua",
        "last_name": "Cognome",
        "phone_landline": "Numero fisso",
        "phone_mobile": "Numero di cellulare",
        "status": "Stato"
      },
      "import": {
        "fill_customer_info": "Compili il modello con le informazioni del cliente",
        "fix_file_upload_customer": "Corregga i problemi e carichi di nuovo il file.</br>I clienti esistenti non verranno rimossi, ma saranno aggiornati se nel file è cambiato qualcosa per quel cliente dall'ultimo caricamento."
      },
      "labels": {
        "customerAddedState": "<b>Non ancora invitato.</b> Un'email di invito verrà inviata quando {name} otterrà l'accesso a un'unità assegnata.",
        "customerAddedStateNoEmailAddress": "<b>Nessun indirizzo email noto.</b> È necessario un indirizzo email per dare a {name} l'accesso a un'unità assegnata.",
        "display": "Visualizzazione",
        "hasAccessToUnit": "Ha accesso online all'unità",
        "information": "Le Sue informazioni",
        "noCustomersYet": "Nessun cliente sulla piattaforma",
        "noEmailAddress": "Nessun indirizzo email",
        "noProject": "Nessun progetto ancora assegnato",
        "noUnits": "Nessuna unità ancora assegnata",
        "notSharedWithCustomer": "Non visibile al cliente",
        "notificationDisclaimer": "Ogni volta che è disponibile un nuovo contenuto per Lei, riceverà una notifica. Se non ha ancora letto queste notifiche sulla piattaforma, verranno raggruppate e inviate in un'email. Di seguito può disattivare le notifiche su determinati argomenti e aumentare o diminuire la frequenza delle email.",
        "onPlatform": "Sulla piattaforma",
        "otherSettings": "Altre impostazioni",
        "password": "Password",
        "primaryContact": "I Suoi dati",
        "project": "Progetto",
        "secondaryContact": "Contatto secondario",
        "sharedWithCustomer": "Visibile al cliente",
        "sorting": "Ordinamento",
        "units": "Unità",
        "viaEmail": "Via email"
      },
      "messages": {
        "integrationUpdateInformation": "Ci contatti se desidera aggiornare alcune informazioni.",
        "userlessProfileNotice": "Questo profilo non ha un indirizzo email collegato."
      },
      "toasts": {
        "birthday": "Buon compleanno, {first_name}!",
        "create": "Cliente aggiunto",
        "delete": "Cliente eliminato",
        "update": "Cliente aggiornato",
        "upload": "Tutti i clienti importati con successo"
      },
      "validation": {
        "needFirstName": "Nome obbligatorio",
        "needFirstNameSecondary": "Nome del contatto secondario obbligatorio",
        "needLastName": "Cognome obbligatorio",
        "needLastNameSecondary": "Cognome del contatto secondario obbligatorio"
      }
    }
  }
}
